module.exports = __webpack_public_path__ + "img/icon-pause.5e7c6d3a.svg";